/**
 * Position enum
 *
 * @export
 * @enum {string}
 *
 */
export var PositionEnum;
(function (PositionEnum) {
    PositionEnum["TOP_RIGHT"] = "top-right";
    PositionEnum["TOP_LEFT"] = "top-left";
    PositionEnum["TOP_CENTER"] = "top-center";
    PositionEnum["BOTTOM_RIGHT"] = "bottom-right";
    PositionEnum["BOTTOM_LEFT"] = "bottom-left";
    PositionEnum["BOTTOM_CENTER"] = "bottom-center";
})(PositionEnum || (PositionEnum = {}));
//# sourceMappingURL=position.enum.js.map